// src/app/providers/AppProvider.tsx
import React from 'react';
import QueryProvider from './QueryProvider';
import AntdConfigProvider from './AntdConfigProvider';
// import { AuthProvider } from './AuthContext'; // If you decide to use a React Context for auth

type AppProviderProps = {
  children: React.ReactNode;
};

function AppProvider({ children }: AppProviderProps) {
  return (
    <AntdConfigProvider>
      <QueryProvider>
        {/*
          <AuthProvider>
            {children}
          </AuthProvider>
        */}
        {children}
      </QueryProvider>
    </AntdConfigProvider>
  );
}

export default AppProvider;